import type { Payload } from '@hapi/boom';
import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios, { Method } from 'axios';
import type { AxiosRequestConfig, AxiosError } from 'axios';

interface AxiosBaseQuery {
  baseUrl?: string;
}

interface QueryArgs extends AxiosRequestConfig {
  url: string;
  method: Method;
}

export interface AxiosBaseQueryError {
  status?: number;
  data?: Payload; // All errors from node server should be Boomified
}

type AxiosBaseQueryResult = BaseQueryFn<QueryArgs, unknown, unknown>;

export function axiosBaseQuery(input: AxiosBaseQuery): AxiosBaseQueryResult {
  const baseUrl = input.baseUrl ?? '';

  return async (queryArgs) => {
    try {
      const url = `${baseUrl}${queryArgs.url}`;

      const headers = {
        ...queryArgs.headers,
      };

      const result = await axios({
        ...queryArgs,
        url,
        headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      // All errors from Node server should be in Boom format
      const err = axiosError as AxiosError<Payload>;
      const error: AxiosBaseQueryError = {
        status: err.response?.status,
        data: err.response?.data,
      };
      return {
        error,
        meta: {
          // Leave a hint, in case RTK error middleware wants to know
          // if the error comes from axios
          type: 'axios',
          request: err.config,
          response: err.response,
        },
      };
    }
  };
}
